import React from 'react';

const NeedHelp = () => {
  return (
    <p>
      Call us at <va-telephone contact="8008271000" />. We're here Monday
      through Friday, 8:00 a.m to 9:00 p.m ET. If you have hearing loss, call{' '}
      <va-telephone contact="711" tty />.
    </p>
  );
};

export default NeedHelp;
